import http from "./api";

//项目名称模糊查询
export const getProjectList = data => {
  return http({
    url: "/complaint/interface/findProjectName",
    method: "post",
    data
  });
};
//发送短信验证码
export const registerYzm = data => {
  return http({
    url: "/complaint/interface/sendSmsJining",
    method: "post",
    data
  });
};

//区市
export const getArea = data => {
  return http({
    url: "/complaint/interface/getAreaChild",
    method: "post",
    data
  });
};

//行业主管列表
export const getIndustry = () => {
  return http({
    url: "/complaint/interface/getIndustry",
    method: "post"
  });
};

//提交
export const submit = data => {
  return http({
    url: "/complaint/interface/add",
    method: "post",
    data
  });
};
// 提交前获取验证码
export const getCheckCode = data => {
  return http({
    url: "/complaint/interface/getCaptcha",
    method: "post",
    responseType: "blob",
    isFile: true,
    notDownload: true,
    data
  });
};

export default {
  getProjectList,
  registerYzm,
  getArea,
  getIndustry,
  getCheckCode,
  submit
};
